import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, RotateCcw } from 'lucide-react';

const Widerruf = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-cream-white via-soft-gray to-cream-white">
      {/* Header with Back Button */}
      <div className="bg-charcoal text-cream-white py-8">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-warm-sage hover:text-soft-taupe transition-colors mb-6"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour à l'accueil
          </Link>
          <div className="flex items-center space-x-4">
            <div className="bg-warm-sage/20 p-3 rounded-lg">
              <RotateCcw className="h-8 w-8 text-warm-sage" />
            </div>
            <div>
              <h1 className="text-3xl md:text-4xl font-serif font-light">
                Droit de Rétractation
              </h1>
              <p className="text-warm-gray font-light mt-1">
                Informations sur le droit de rétractation
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
          
          <div className="prose prose-lg max-w-none">
            <p className="text-warm-gray italic mb-8">
              Dernière mise à jour : Janvier 2025
            </p>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Droit de Rétractation
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Conformément aux dispositions du Code de la consommation français et européen, vous disposez d'un délai de 
                <strong className="text-warm-sage"> 14 jours calendaires</strong> pour exercer votre droit de rétractation sans avoir à justifier de motifs ni à payer de pénalité.
              </p>
              <p className="text-charcoal leading-relaxed">
                Ce délai court à compter du jour de la conclusion du contrat (c'est-à-dire la confirmation de votre réservation).
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Modalités d'Exercice du Droit de Rétractation
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                Pour exercer votre droit de rétractation, vous devez nous notifier votre décision de manière explicite par :
              </p>
              <ul className="list-disc pl-6 space-y-2 text-charcoal mb-4">
                <li>Email à : <a href="mailto:contact@mindup-coaching.com" className="text-warm-sage hover:underline">contact@mindup-coaching.com</a></li>
                <li>Courrier postal à l'adresse indiquée dans les mentions légales</li>
              </ul>
              <p className="text-charcoal leading-relaxed">
                Vous pouvez utiliser le modèle de formulaire de rétractation ci-dessous, mais ce n'est pas obligatoire.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Effets de la Rétractation
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                En cas de rétractation de votre part dans le délai de 14 jours, nous vous rembourserons tous les paiements reçus de votre part, 
                sans retard excessif et, en tout état de cause, au plus tard 14 jours à compter du jour où nous sommes informés de votre décision 
                de rétractation.
              </p>
              <p className="text-charcoal leading-relaxed">
                Nous procéderons au remboursement en utilisant le même moyen de paiement que celui que vous avez utilisé pour la transaction initiale, 
                sauf accord exprès contraire de votre part.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Exception : Début d'Exécution du Service
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                <strong className="text-warm-sage">Important :</strong> Si vous demandez expressément le début de l'exécution du service 
                (c'est-à-dire une séance de coaching) avant l'expiration du délai de rétractation de 14 jours, vous perdez votre droit de rétractation 
                dès que le service a été pleinement exécuté.
              </p>
              <p className="text-charcoal leading-relaxed">
                Dans ce cas, vous serez informé(e) et devrez donner votre consentement explicite avant le début de la prestation.
              </p>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Modèle de Formulaire de Rétractation
              </h2>
              <div className="bg-soft-gray/20 p-6 rounded-xl border border-warm-sage/20">
                <p className="text-charcoal leading-relaxed italic mb-4">
                  (Veuillez compléter et renvoyer ce formulaire uniquement si vous souhaitez vous rétracter)
                </p>
                <div className="space-y-4 text-charcoal">
                  <p>À l'attention de Mind'UP - Sanaa Ait Balla<br />
                  Email : contact@mindup-coaching.com</p>
                  
                  <p>Je/Nous (*) vous notifie/notifions (*) par la présente ma/notre (*) rétractation du contrat portant sur la prestation de services ci-dessous :</p>
                  
                  <p>
                    - Commandé le (*) / reçu le (*) : _______________________<br />
                    - Nom du (des) consommateur(s) : _______________________<br />
                    - Adresse du (des) consommateur(s) : _______________________<br />
                    - Signature du (des) consommateur(s) (uniquement en cas de notification du présent formulaire sur papier) : _______________________<br />
                    - Date : _______________________
                  </p>
                  
                  <p className="text-xs">(*) Rayez la mention inutile.</p>
                </div>
              </div>
            </section>

            <section className="mb-10">
              <h2 className="text-2xl font-serif font-light text-charcoal mb-4 border-b border-warm-sage/20 pb-2">
                Informations Complémentaires
              </h2>
              <p className="text-charcoal leading-relaxed mb-4">
                <strong>Séance Découverte Gratuite :</strong> La séance découverte de 30 minutes offerte n'est pas soumise au droit de rétractation 
                car elle est gratuite et constitue une découverte du service sans engagement.
              </p>
              <p className="text-charcoal leading-relaxed">
                <strong>Programmes et Packages :</strong> Pour les programmes comprenant plusieurs séances, le droit de rétractation s'applique avant 
                le début de la première séance, sauf demande expresse d'exécution immédiate de votre part.
              </p>
            </section>

            <div className="bg-warm-sage/10 p-6 rounded-xl border border-warm-sage/20 mt-12">
              <p className="text-charcoal leading-relaxed">
                <strong className="text-warm-sage">Questions ?</strong><br />
                Pour toute question concernant le droit de rétractation, veuillez nous contacter à :<br />
                <a href="mailto:contact@mindup-coaching.com" className="text-warm-sage hover:underline">
                  contact@mindup-coaching.com
                </a>
              </p>
            </div>
          </div>

        </div>

        {/* Back to Home Button */}
        <div className="text-center mt-8">
          <Link 
            to="/" 
            className="inline-flex items-center text-warm-sage hover:text-charcoal transition-colors"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour à l'accueil
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Widerruf;
